const behaviorWithPeople = [
    { value: 'friendly', label: { en: 'Friendly', es: 'Amistoso' } },
    { value: 'calm', label: { en: 'Calm', es: 'Calmado' } },
    { value: 'playful', label: { en: 'Playful', es: 'Juguetón' } },
    { value: 'protective', label: { en: 'Protective', es: 'Protector' } },
    { value: 'shy', label: { en: 'Shy', es: 'Tímido' } },
    { value: 'aggressive', label: { en: 'Aggressive', es: 'Agresivo' } },
    { value: 'independent', label: { en: 'Independent', es: 'Independiente' } },
    { value: 'unknown', label: { en: 'Unknown', es: 'Desconocido' } },
];

export default behaviorWithPeople;